import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    selectedTagsContainer: { // OK
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        padding: '0px',
        [theme.breakpoints.down('md')]: {
            rowGap: 12,
            columnGap: 10
        },
        [theme.breakpoints.up('md')]: {
            rowGap: 10,
            columnGap: 10
        }
    },
    menuItem: {
        padding: '6px 20px'
    },
    tagList: {
        marginLeft: 20
    },
    selectAll: {
        width: 'fit-content',
        color: 'var(--foreground-black)', // Did not use theme.xxx for color here, because it breaks in admin
        backgroundColor: 'var(--background-grey-light)', // Did not use theme.xxx for color here, because it breaks in admin
        border: '1px solid var(--foreground-black)', // Did not use theme.xxx for color here, because it breaks in admin
        fontFamily: 'GreedStandard-Medium',
        fontSize: '13px',
        lineHeight: '18px',
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px',
        cursor: 'pointer',
        borderRadius: 50,
        padding: '6px 8px'
    }
}))
